// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/chevron-haut.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/logout.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/cart.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/menu.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 768px) {
  .access_rapide,
  .bloc_reassurance {
    display: none !important; } }

@media screen and (max-width: 767px) {
  .mobile {
    display: flex;
    align-items: center; }
    .mobile > div {
      margin: 0 8px; }
  .advtm_menu_5 .adtm_sub .subsubmenu_category li > div {
    display: flex;
    padding: 0 !important;
    margin: 0 !important; }
  .advtm_menu_5 .adtm_sub .subsubmenu_category li > div > div {
    width: 50%;
    padding: 0 !important;
    margin: 0 !important; }
  .advtm_menu_5 .adtm_sub .subsubmenu_category li > div > div a:after {
    content: none !important; }
  .advtm_menu_5 .adtm_sub .subsubmenu_category li > div > div .column_wrap_title {
    margin: 5px !important; }
  .advtm_menu_5 .adtm_sub .subsubmenu_category {
    min-height: 80vh !important; }
  #adtm_menu.adtm_menu_toggle_open ul#menu li div.adtm_sub {
    height: 80vh !important; }
  #_mobile_top_menu {
    max-width: 80%;
    display: none;
    overflow: scroll;
    position: absolute !important;
    top: 0;
    right: -100%;
    margin: 0;
    background: white;
    height: 100vh;
    z-index: 800; }
    #_mobile_top_menu .burger_header {
      padding: 28px 20px 10px 20px;
      display: flex;
      justify-content: space-between;
      background: white; }
    #_mobile_top_menu .mobile_mode {
      padding: 30px;
      position: relative;
      display: flex; }
      #_mobile_top_menu .mobile_mode .close_icon {
        margin-left: auto; }
    #_mobile_top_menu .adtm_submenu_toggle_open .columnWrapTable {
      display: none; }
    #_mobile_top_menu .back_sub span {
      padding: 0; }
    #_mobile_top_menu .li-niveau1 a:hover:after {
      display: none !important; }
    #_mobile_top_menu .language-selector-wrapper select {
      -webkit-appearance: none;
      -moz-appearance: none;
      text-indent: 1px;
      text-overflow: ''; }
    #_mobile_top_menu .sub,
    #_mobile_top_menu .li-niveau1 a.a-niveau1 {
      border: none !important; }
    #_mobile_top_menu .adtm_sub {
      border: none !important; }
      #_mobile_top_menu .adtm_sub .back {
        display: none; }
    #_mobile_top_menu .adtm_sub_open {
      height: 100%;
      transition: 0.5s all ease-in-out;
      padding-left: 0;
      top: 0;
      position: absolute;
      z-index: 100000;
      background: white;
      width: 100%;
      left: 0; }
      #_mobile_top_menu .adtm_sub_open a.a-niveau1 {
        flex-direction: row-reverse; }
    #_mobile_top_menu .advtm_menu_span {
      font-weight: initial; }
    #_mobile_top_menu ul#menu li.li-niveau1 span {
      background: white !important; }
  .background_opacity_menu {
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    display: block;
    position: fixed;
    z-index: 12;
    top: 0;
    height: 110%; }
  .bloc_reassurance {
    padding: 40px;
    border-top: 1px solid #ece6dc;
    text-align: center; }
  .access_rapide {
    display: flex;
    justify-content: center; }
    .access_rapide a {
      margin: auto;
      color: black; } }

@media screen and (max-width: 800px) {
  #_mobile_top_menu #menu {
    padding-left: 15px !important;
    padding-right: 25px !important; }
  #adtm_menu .li-niveau1 {
    margin-bottom: 15px; }
  #adtm_menu .adtm_elements li a {
    padding-left: 0 !important; }
  #adtm_menu .li-niveau1,
  #adtm_menu .li-niveau1 a.a-niveau1,
  #adtm_menu .li-niveau1 a.a-niveau1 .advtm_menu_span {
    line-height: 1;
    min-height: 0 !important;
    max-height: 25px !important;
    font-size: 1rem !important;
    color: black;
    text-transform: none !important;
    font-weight: 300 !important; }
  #adtm_menu .li-niveau1 a.a-niveau1 > span {
    display: flex !important;
    align-items: center !important;
    position: relative; }
  #adtm_menu .li-niveau1 a.a-niveau1 > :after {
    content: "";
    display: block;
    width: 7px;
    height: 7px;
    border: solid 2px #153147;
    position: absolute;
    right: -5px;
    transform: rotate(45deg);
    border-left: none;
    border-bottom: none; }
  #_mobile_top_menu .close_icon {
    opacity: 1;
    text-align: right; }
    #_mobile_top_menu .close_icon img {
      width: auto;
      height: auto; }
  #_mobile_top_menu .burger_header .close_icon {
    margin: 0 !important;
    position: relative; }
  #_mobile_top_menu .close_icon:after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    display: block;
    width: 18px;
    height: 18px; }
  #_mobile_top_menu .mobile_mode {
    padding-left: 15px; }
  #_mobile_top_menu .mobile_mode .dropdown select {
    color: black;
    font-weight: normal !important;
    font-family: "Oswald", sans-serif; }
  #_mobile_top_menu .mobile_mode .dropdown img {
    height: 15px;
    width: auto;
    margin-left: 5px; }
  #_mobile_top_menu .mobile_mode .dropdown {
    display: flex;
    align-items: center; }
  #_mobile_top_menu .back_sub {
    cursor: pointer; }
  #_mobile_top_menu .adtm_sub a {
    color: #252626 !important;
    position: relative;
    font-family: "Roboto", sans-serif;
    font-weight: 300 !important; }
  #_mobile_top_menu .adtm_sub > .columnWrapTable {
    padding: 0 15px; }
  #_mobile_top_menu .next_sub {
    position: absolute;
    right: 0;
    top: 0;
    width: 50px;
    height: 20px; }
  #_mobile_top_menu .adtm_sub .column_wrap_title .next_sub:after {
    content: "";
    display: block;
    width: 10px;
    height: 10px;
    border: solid 2px #F08243;
    position: absolute;
    right: 5px;
    transform: translate(0, -50%) rotate(45deg);
    border-left: none;
    border-bottom: none;
    top: 10px; }
  #_mobile_top_menu .adtm_sub .subsubmenu_category > li .adtm_column_wrap,
  #_mobile_top_menu .adtm_sub .subsubmenu_category > li .adtm_column_wrap .subcategoryTrue {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin: 0 !important; }
  #_mobile_top_menu .adtm_sub .subsubmenu_category > li .adtm_column_wrap .adtm_column_wrap_sizer {
    display: none; }
  #_mobile_top_menu .adtm_sub p {
    padding: 0 10px; }
  #_mobile_top_menu .adtm_sub .adtm_column .column_wrap_title {
    position: relative;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important; }
  #_mobile_top_menu .adtm_sub,
  #_mobile_top_menu .subsubmenu_category {
    padding-top: 10px; } }

#_mobile_top_menu .access_rapide {
  margin-left: 30px;
  margin-right: 25px;
  margin-top: 25px;
  flex-wrap: wrap;
  display: flex;
  padding: 10px 10px 0;
  box-shadow: 0 3px 6px #00000029; }

#_mobile_top_menu .access_rapide a {
  width: 100%;
  margin-bottom: 15px; }

#_mobile_top_menu .access_rapide a img {
  width: 17px;
  margin-right: 10px; }

.burger_header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; }

.burger_header .back_sub {
  font-size: 14px;
  font-weight: 300;
  display: flex;
  align-items: center;
  width: 50%; }

.burger_header .close_icon:after {
  width: 50%;
  position: absolute;
  right: 0; }

.burger_header .close_icon {
  width: 50%; }

.burger_header .sub_title {
  width: 100%;
  margin-top: 25px;
  padding-left: 5px;
  color: #F08243 !important;
  font-size: 20px;
  font-weight: 600 !important; }

.burger_header .sub_title .advtm_menu_span {
  color: #F08243;
  font-weight: 700 !important;
  font-size: 20px; }

.background_opacity_menu {
  display: none !important; }

#header.is-open:before {
  content: '';
  display: block;
  max-width: 20%;
  background: rgba(32, 31, 31, 0.7);
  height: 100vh;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 9; }

#category #amazzing_filter {
  box-shadow: none !important; }

@media screen and (max-width: 767px) {
  #category #js-product-list-header {
    margin-bottom: 15px; } }

#category #js-product-list-header .read_less,
#category #js-product-list-header .read_more {
  margin-top: 5px;
  font-size: 14px;
  font-weight: bolder; }

@media screen and (max-width: 767px) {
  #category #js-product-list-header .block-category h1 {
    font-size: 1.5rem; } }

@media screen and (max-width: 767px) {
  main {
    overflow-x: hidden; } }

@media screen and (min-width: 768px) {
  .header-top {
    display: flex;
    align-items: center;
    justify-content: center; } }

#checkout .cart-grid-body .nav-link {
  font-size: 0.9rem; }

.product-line-grid-right .qty {
  padding-right: 0; }

#prestablogfront .date {
  display: none; }

#header .header-nav {
  border: none; }
  @media screen and (max-width: 767px) {
    #header .header-nav .row {
      margin: 0 !important; } }
  #header .header-nav .user-info {
    margin-left: 0 !important;
    margin-right: 1rem; }

#header .header-banner ul li * {
  font-family: "Montserrat", sans-serif;
  font-weight: 400; }

#header .header-banner .splide {
  overflow: hidden;
  max-height: 56px; }
  #header .header-banner .splide .splide__slide {
    text-align: center;
    line-height: 56px; }
  #header .header-banner .splide .close_element {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    float: right;
    position: relative;
    top: -40px;
    right: 40px;
    color: white;
    cursor: pointer; }

#products .product-title {
  min-height: 40px; }

#product .input-group {
  max-width: 80px;
  text-align: center;
  border-radius: 10px; }

#product .h1 {
  text-transform: initial !important; }

.block-category-inner {
  flex-direction: column; }

.product-actions {
  border: none !important;
  padding: 0 !important;
  margin: 0 0 30px !important; }

.icon-amz {
  margin-right: 10px; }

.product-actions .add a {
  display: flex;
  align-items: center;
  justify-content: center; }

.btn-primary {
  background-color: #163047 !important; }

h1, h2, h3, h4, h5, h6, p, span, a {
  font-family: "Inter", sans-serif !important; }

#header-pickleball {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 15px 0;
  transition: all .15s ease; }

.header-top .container {
  width: 1280px; }
  .header-top .container #menu {
    justify-content: center !important; }

header#header {
  transition: transform .30s ease;
  transform: translateY(0px);
  width: 100%;
  top: 0;
  z-index: 200; }
  header#header #_desktop_cart {
    order: 2; }
  header#header #adtm_menu ul#menu {
    justify-content: center !important; }
  @media screen and (max-width: 767px) {
    header#header {
      width: 100vw; } }
  header#header #header-pickleball-wrapper {
    background: white; }
    @media screen and (min-width: 768px) {
      header#header #header-pickleball-wrapper {
        padding-top: 20px; } }
    header#header #header-pickleball-wrapper #header-pickleball {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      padding: 0;
      transition: all .15s ease; }
      @media screen and (max-width: 767px) {
        header#header #header-pickleball-wrapper #header-pickleball .logo-wrapper {
          order: 1;
          padding-bottom: 10px;
          width: 45%; } }
      @media screen and (min-width: 768px) {
        header#header #header-pickleball-wrapper #header-pickleball .logo-wrapper {
          padding-top: 10px; } }
      @media screen and (max-width: 767px) {
        header#header #header-pickleball-wrapper #header-pickleball .logo-wrapper img {
          width: 200px !important; } }
      header#header #header-pickleball-wrapper #header-pickleball .search-wrapper {
        width: 543px;
        max-width: 100%;
        padding-top: 14px; }
        @media screen and (max-width: 767px) {
          header#header #header-pickleball-wrapper #header-pickleball .search-wrapper {
            order: 3;
            width: 100%;
            margin: 0 0 0 0; } }
        header#header #header-pickleball-wrapper #header-pickleball .search-wrapper #search_widget {
          float: none; }
          header#header #header-pickleball-wrapper #header-pickleball .search-wrapper #search_widget i {
            padding: 0;
            right: 5px;
            top: 17px;
            color: #163047 !important; }
          header#header #header-pickleball-wrapper #header-pickleball .search-wrapper #search_widget input {
            border-radius: 0;
            padding: 5px 35px 5px 5px;
            height: 55px; }
      header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper {
        flex-shrink: 0;
        display: flex;
        align-items: center; }
        @media screen and (max-width: 767px) {
          header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper {
            order: 2; } }
        header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper a {
          cursor: pointer; }
        @media screen and (min-width: 768px) {
          header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper {
            padding-top: 14px; }
            header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper > div {
              margin: 0 11px; } }
        @media screen and (max-width: 767px) {
          header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper .icon-header {
            width: 17px;
            height: 15px; } }
        @media screen and (max-width: 767px) {
          header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #_desktop_user_info,
          header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #_desktop_cart {
            display: none; } }
        header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #_mobile_cart,
        header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #_mobile_user_info {
          display: none; }
          @media screen and (max-width: 767px) {
            header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #_mobile_cart,
            header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #_mobile_user_info {
              display: block; } }
        header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #_desktop_user_info {
          order: 1; }
          header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #_desktop_user_info img {
            width: auto; }
        header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #_mobile_user_info {
          order: 2; }
        header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #icon-wishlist-wrapper {
          order: 3; }
        header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #ps-shoppingcart-wrapper {
          order: 4; }
          @media screen and (max-width: 767px) {
            header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #ps-shoppingcart-wrapper {
              order: 1; } }
        header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #_mobile_cart {
          order: 5; }
        header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #menu-icon {
          display: none;
          order: 6; }
          @media screen and (max-width: 767px) {
            header#header #header-pickleball-wrapper #header-pickleball .icons-wrapper #menu-icon {
              display: block; } }
      header#header #header-pickleball-wrapper #header-pickleball .blockcart, header#header #header-pickleball-wrapper #header-pickleball #icon-wishlist-wrapper {
        position: relative; }
        header#header #header-pickleball-wrapper #header-pickleball .blockcart .wishlist-products-count,
        header#header #header-pickleball-wrapper #header-pickleball .blockcart .cart-products-count, header#header #header-pickleball-wrapper #header-pickleball #icon-wishlist-wrapper .wishlist-products-count,
        header#header #header-pickleball-wrapper #header-pickleball #icon-wishlist-wrapper .cart-products-count {
          position: absolute;
          top: -3px;
          background-color: #EB622E;
          color: white;
          bottom: -8px;
          right: -5px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          width: 17px;
          height: 17px;
          font-size: 12px; }
          @media screen and (max-width: 767px) {
            header#header #header-pickleball-wrapper #header-pickleball .blockcart .wishlist-products-count,
            header#header #header-pickleball-wrapper #header-pickleball .blockcart .cart-products-count, header#header #header-pickleball-wrapper #header-pickleball #icon-wishlist-wrapper .wishlist-products-count,
            header#header #header-pickleball-wrapper #header-pickleball #icon-wishlist-wrapper .cart-products-count {
              bottom: -10px; } }
  header#header.sticky {
    width: 100%; }
    header#header.sticky.partial {
      transform: translateY(-150px); }
      @media screen and (max-width: 767px) {
        header#header.sticky.partial {
          transform: translateY(0); } }
      header#header.sticky.partial #header-wimod-wrapper #header-wimod {
        padding: 0; }
        @media screen and (max-width: 767px) {
          header#header.sticky.partial #header-wimod-wrapper #header-wimod {
            padding: 5px 0 0 0; } }
        @media screen and (max-width: 767px) {
          header#header.sticky.partial #header-wimod-wrapper #header-wimod .logo-wrapper,
          header#header.sticky.partial #header-wimod-wrapper #header-wimod .icons-wrapper {
            display: none; } }

@media screen and (max-width: 767px) {
  .breadcrumb {
    font-size: 12px; }
  .product-container .product-price .current-price .current-price-value {
    font-size: 20px;
    font-weight: bolder; } }

.caracteristic-name {
  font-weight: bolder; }

.product-container .h1 {
  font-size: 1.6rem;
  font-weight: 500; }

.product-container .product-price {
  display: inline-block;
  max-width: 100%;
  color: #232323; }

.card-header {
  background-color: white;
  padding-left: 0; }
  .card-header h2 {
    margin-bottom: 0 !important;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    appearance: none;
    outline: none;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.14rem;
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    color: #232323; }
    .card-header h2:after {
      width: 16px;
      height: 9px;
      display: block;
      transform-origin: bottom;
      content: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }

@media screen and (min-width: 768px) {
  .product-container .product-price .current-price .current-price-value {
    font-size: 24px;
    font-weight: bolder; } }

@media screen and (max-width: 767px) {
  .product-quantity .add {
    width: 100%; }
    .product-quantity .add button {
      width: 100%; } }

.product-quantity #quantity_wanted {
  text-align: center;
  width: 3rem;
  height: 2.75rem;
  padding: .175rem .5rem;
  color: #232323;
  background-color: #fff;
  border: 1px solid #232323; }

.product-quantity .input-group-btn-vertical {
  display: none; }

#quantity_wanted,
.add-to-cart {
  border-radius: 10px; }

.product-accessories {
  margin-top: 50px;
  background-color: #eeeeee; }
  .product-accessories .products-slider-wrapper {
    max-width: 100%;
    overflow-x: auto;
    padding: 0 0 1rem 0; }
    .product-accessories .products-slider-wrapper .products {
      margin: 0;
      flex-wrap: nowrap; }
      .product-accessories .products-slider-wrapper .products .product {
        padding: 0;
        width: 212px;
        margin: 0 8px 0 0;
        flex-shrink: 0;
        position: relative; }
  @media screen and (min-width: 768px) {
    .product-accessories {
      padding: 24px 0; } }
  @media screen and (max-width: 767px) {
    .product-accessories {
      padding: 24px 15px; } }
  .product-accessories .h5 {
    margin: 0 0 24px 0;
    font-size: 2.14rem;
    text-transform: initial !important; }

#product #content {
  max-width: initial; }

#product #content-wrapper {
  padding-left: 0;
  padding-right: 0; }

@media screen and (max-width: 767px) {
  #product #accordion-infos {
    padding: 0 15px; } }

#product #accordion-infos li, #product #accordion-infos span,
#product #accordion-infos #description-truncate {
  font-size: 13px; }

#product #accordion-infos .caracteristics .product-features {
  margin: 0; }
  #product #accordion-infos .caracteristics .product-features dl.data-sheet .name,
  #product #accordion-infos .caracteristics .product-features dl.data-sheet .value {
    min-height: initial;
    padding: 20px 0;
    margin: 0;
    background-color: white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    font-size: 13px; }

.position-relative {
  position: relative; }
  @media screen and (min-width: 768px) {
    .position-relative #_desktop_language_selector {
      position: absolute;
      right: 0; } }
  @media screen and (max-width: 767px) {
    .position-relative #_desktop_language_selector {
      padding: 5px;
      text-align: center; } }

@media screen and (min-width: 768px) {
  #header-pickleball #_desktop_language_selector {
    display: none; } }

.user-info {
  display: flex;
  gap: 10px; }
  .user-info a {
    display: flex;
    align-items: center; }
  .user-info .icon-custom-logout {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }
  .user-info .icon-custom-user {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }
    @media screen and (min-width: 768px) {
      .user-info .icon-custom-user {
        width: 30px; } }
    @media screen and (max-width: 767px) {
      .user-info .icon-custom-user {
        height: 30px; } }

.blockcart .icon-custom-cart {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  top: 3px;
  position: relative; }
  @media screen and (min-width: 768px) {
    .blockcart .icon-custom-cart {
      width: 35px; } }
  @media screen and (max-width: 767px) {
    .blockcart .icon-custom-cart {
      height: 37px;
      top: 2px; } }

@media screen and (max-width: 767px) {
  .blockcart .cart-products-count {
    top: 0 !important; } }

.icon-custom-burger {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  height: 38px;
  top: 5px;
  position: relative; }

.product-miniature .thumbnail-container:hover .product-description::after {
  content: none !important; }

.has-discount .discount,
.product-flags li.product-flag.discount, .product-flags li.product-flag.discount-amount, .product-flags li.product-flag.discount-percentage {
  background-color: #ef612d; }

.has-discount .page-content.page-cms ul, .has-discount p, .has-discount.product-price, .page-content.page-cms .has-discount ul {
  color: #ef612d; }

.block-contact, .footer-container li a,
.tabs .nav-tabs .nav-link,
p {
  color: black; }

.block_newsletter form input[type=email],
#search_widget form input {
  height: 55px;
  background-color: white !important;
  border: 1px solid #163047 !important;
  border-radius: 10px !important;
  padding: 5px 35px 5px 15px !important;
  font-size: 20px;
  font-weight: 700; }

@media screen and (max-width: 767px) {
  .product-information .product-description ul {
    padding: 0; }
  .slick_images .image img {
    width: 100%;
    height: auto; }
  .js-product-container .scroll-box-arrows {
    display: none; }
  .slick-dots li button:before {
    font-size: 50px;
    color: #EB622E !important; } }

.product-miniature .product-title a {
  color: black; }

.product-miniature .product-title {
  height: 40px; }

.d-flex {
  display: flex;
  align-items: center;
  gap: 10px; }

.block_bas h3 {
  min-height: 40px !important; }

.blog_desc {
  height: 100px; }

.text-center {
  text-align: center; }

#product #wrapper .product-add-to-cart.stuck-down {
  position: fixed;
  z-index: 250;
  left: 15px;
  width: calc(100% - 30px);
  bottom: 15px;
  border-top: 1px solid #163047;
  box-shadow: 0 -1px 6px #163047; }
  #product #wrapper .product-add-to-cart.stuck-down .product-prices {
    text-align: center;
    margin-top: 0; }
    #product #wrapper .product-add-to-cart.stuck-down .product-prices > div {
      margin-bottom: 0; }
  @media screen and (max-width: 767px) {
    #product #wrapper .product-add-to-cart.stuck-down {
      transition: opacity;
      animation: moveToBottom 0.5s ease-in-out 1;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 15px 15px 0 15px;
      background: #FFF; } }

#product #wrapper .container-pickleball {
  max-width: 1140px;
  margin: auto; }

#product #wrapper .container {
  width: 100%;
  max-width: none; }

#product #wrapper .breadcrumb {
  margin-bottom: 1rem; }
  @media screen and (max-width: 767px) {
    #product #wrapper .breadcrumb {
      max-width: 100%;
      overflow-x: auto; }
      #product #wrapper .breadcrumb ol {
        display: flex; }
        #product #wrapper .breadcrumb ol li {
          display: block;
          white-space: nowrap; } }
  #product #wrapper .breadcrumb ol li span,
  #product #wrapper .breadcrumb ol li a {
    font-size: 0.8rem; }
`, "",{"version":3,"sources":["webpack://./_dev/front/components/menu.scss","webpack://./_dev/front/components/category.scss","webpack://./_dev/front/front.scss"],"names":[],"mappings":"AAOA;EACE;;IAEE,wBAAwB,EAAA,EACzB;;AAGH;EACE;IACE,aAAa;IACb,mBAAmB,EAAA;IAFrB;MAII,aAAa,EAAA;EAGjB;IACE,aAAa;IACb,qBAAqB;IACrB,oBAAoB,EAAA;EAEtB;IACE,UAAU;IACV,qBAAqB;IACrB,oBAAoB,EAAA;EAGtB;IACE,wBAAwB,EAAA;EAG1B;IACE,sBAAsB,EAAA;EAExB;IACE,2BAA2B,EAAA;EAG7B;IACE,uBAAuB,EAAA;EAGzB;IACE,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,MAAM;IACN,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,YAAY,EAAA;IAVd;MAaI,4BAA4B;MAC5B,aAAa;MACb,8BAA8B;MAC9B,iBAAiB,EAAA;IAhBrB;MAoBI,aAAa;MACb,kBAAkB;MAClB,aAAa,EAAA;MAtBjB;QAyBM,iBAAiB,EAAA;IAzBvB;MA+BM,aAAa,EAAA;IA/BnB;MAsCM,UAAU,EAAA;IAtChB;MA8CU,wBAAwB,EAAA;IA9ClC;MAsDM,wBAAwB;MACxB,qBAAqB;MACrB,gBAAgB;MAChB,iBAAiB,EAAA;IAzDvB;;MA+DI,uBAAuB,EAAA;IA/D3B;MAmEI,uBAAuB,EAAA;MAnE3B;QAsEM,aAAa,EAAA;IAtEnB;MA2EI,YAAY;MACZ,gCAAgC;MAChC,eAAe;MACf,MAAM;MACN,kBAAkB;MAClB,eAAe;MACf,iBAAiB;MACjB,WAAW;MACX,OAAO,EAAA;MAnFX;QAsFM,2BAA2B,EAAA;IAtFjC;MA2FI,oBAAqB,EAAA;IA3FzB;MAgGM,4BAA4B,EAAA;EAIlC;IACE,oCAAoC;IACpC,WAAW;IACX,cAAc;IACd,eAAe;IACf,WAAW;IACX,MAAM;IACN,YAAY,EAAA;EAEd;IACE,aAAa;IACb,6BAA6B;IAC7B,kBAAkB,EAAA;EAEpB;IACE,aAAa;IACb,uBAAuB,EAAA;IAFzB;MAKI,YAAY;MACZ,YAAY,EAAA,EACb;;AAKL;EACE;IACE,6BAA6B;IAC7B,8BAA8B,EAAA;EAGhC;IACE,mBAAmB,EAAA;EAErB;IACE,0BAA0B,EAAA;EAE5B;;;IAGE,cAAc;IACd,wBAAwB;IACxB,2BAA2B;IAC3B,0BAA0B;IAC1B,YAAY;IACZ,+BAA+B;IAC/B,2BAA2B,EAAA;EAE7B;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,kBAAkB,EAAA;EAGpB;IACE,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,iBAAiB;IACjB,mBACF,EAAA;EACA;IACE,UAAU;IACV,iBAAiB,EAAA;IAFnB;MAKI,WAAW;MACX,YAAY,EAAA;EAGhB;IACE,oBAAoB;IACpB,kBAAkB,EAAA;EAEpB;IACE,gDAA8B;IAC9B,cAAc;IACd,WAAW;IACX,YAAY,EAAA;EAEd;IACE,kBAAkB,EAAA;EAEpB;IACE,YAAY;IACZ,8BAA8B;IAC9B,iCAAiC,EAAA;EAGnC;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB,EAAA;EAIlB;IACE,aAAa;IACb,mBAAmB,EAAA;EAIrB;IAEI,eAAe,EAAA;EAFnB;IAMI,yBAAyB;IACzB,kBAAkB;IAClB,iCAAiC;IACjC,2BAA2B,EAAA;EAT/B;IAaI,eAAe,EAAA;EAbnB;IAiBI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;IACX,YAAY,EAAA;EArBhB;IAyBI,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,2CAA2C;IAC3C,iBAAiB;IACjB,mBAAmB;IACnB,SAAS,EAAA;EAnCb;;IAwCI,yBAAyB;IACzB,4BAA4B;IAC5B,oBAAoB,EAAA;EA1CxB;IA+CI,aAAa,EAAA;EA/CjB;IAmDI,eAAe,EAAA;EAnDnB;IAuDI,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B,EAAA;EAzDhC;;IA8DI,iBACF,EAAA,EAAC;;AAIL;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,+BAA+B,EAAA;;AAGjC;EACE,WAAW;EACX,mBACF,EAAA;;AAEA;EACE,WAAW;EACX,kBAAkB,EAAA;;AAIpB;EACE,aAAa;EACb,eAAe;EACf,8BAA8B,EAAA;;AAGhC;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,UAAU,EAAA;;AAGZ;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ,EAAA;;AAGV;EACE,UAAU,EAAA;;AAGZ;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,2BAA2B,EAAA;;AAG7B;EACE,cAAc;EACd,2BAA0B;EAC1B,eAAe,EAAA;;AAGjB;EACE,wBAAwB,EAAA;;AAG1B;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,iCAAiC;EACjC,aAAa;EACb,WAAW;EACX,eAAe;EACf,OAAO;EACP,MAAM;EACN,SAAS;EACT,UACF,EAAA;;AC/YA;EAEI,2BAA2B,EAAA;;AAG3B;EALJ;IAMM,mBAAmB,EAAA,EAgBtB;;AAtBH;;EAUM,eAAe;EACf,eAAe;EACf,mBAAmB,EAAA;;AAKjB;EAjBR;IAkBU,iBAAiB,EAAA,EAEpB;;AChBP;EACE;IACE,kBAAkB,EAAA,EACnB;;AAGH;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA,EACxB;;AAGH;EAGM,iBAAiB,EAAA;;AAKvB;EAEI,gBAAgB,EAAA;;AAIpB;EAEI,aAAa,EAAA;;AAIjB;EAOI,YAAY,EAAA;EALZ;IAFJ;MAIQ,oBAAoB,EAAA,EACrB;EALP;IAUM,yBAAyB;IACzB,kBAAkB,EAAA;;AAXxB;EAmBU,qCAAqC;EACrC,gBAAgB,EAAA;;AApB1B;EA0BM,gBAAgB;EAChB,gBAAgB,EAAA;EA3BtB;IA8BQ,kBAAkB;IAClB,iBAAiB,EAAA;EA/BzB;IAmCQ,gDAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe,EAAA;;AAMvB;EAEI,gBAAgB,EAAA;;AAIpB;EAEI,eAAe;EACf,kBAAkB;EAClB,mBAAmB,EAAA;;AAJvB;EAOI,kCAAkC,EAAA;;AAItC;EACE,sBAAsB,EAAA;;AAGxB;EACE,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B,EAAA;;AAG7B;EACE,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;EACE,oCAAoC,EAAA;;AAGtC;EACE,2CAA2C,EAAA;;AAG7C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB,EAAA;;AAG3B;EAEI,aAAa,EAAA;EAFjB;IAKM,kCAAkC,EAAA;;AAKxC;EASE,+BAA+B;EAC/B,0BAA0B;EAC1B,WAAW;EACX,MAAM;EACN,YAAY,EAAA;EAbd;IAEI,QAAQ,EAAA;EAFZ;IAMI,kCAAkC,EAAA;EAQpC;IAdF;MAeI,YAAY,EAAA,EAkMf;EAjND;IAsBI,iBAAiB,EAAA;IAHjB;MAnBJ;QAoBM,iBAAiB,EAAA,EAiKpB;IArLH;MAyBM,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,eAAe;MACf,UAAU;MACV,yBAAyB,EAAA;MAGvB;QAjCR;UAkCU,QAAQ;UACR,oBAAoB;UACpB,UAAU,EAAA,EAWb;MATC;QAtCR;UAuCU,iBAAiB,EAAA,EAQpB;MAJG;QA3CV;UA4CY,uBAAuB,EAAA,EAE1B;MA9CT;QAkDQ,YAAY;QACZ,eAAe;QACf,iBAAiB,EAAA;QACjB;UArDR;YAsDU,QAAQ;YACR,WAAW;YACX,eAAe,EAAA,EAmBlB;QA3EP;UA4DU,WAAW,EAAA;UA5DrB;YA+DY,UAAU;YACV,UAAU;YACV,SAAS;YACT,yBAAyB,EAAA;UAlErC;YAsEY,gBAAgB;YAChB,yBAAyB;YACzB,YAAY,EAAA;MAxExB;QAiFQ,cAAc;QACd,aAAa;QACb,mBAAmB,EAAA;QALnB;UA9ER;YA+EU,QAAQ,EAAA,EAyEX;QAxJP;UAsFU,eAAe,EAAA;QAGjB;UAzFR;YA0FU,iBAAiB,EAAA;YA1F3B;cA4FY,cAAc,EAAA,EACf;QAID;UAjGV;YAkGY,WAAW;YACX,YAAY,EAAA,EAEf;QAIC;UAzGV;;YA0GY,aAAa,EAAA,EAEhB;QA5GT;;UAgHU,aAAa,EAAA;UACb;YAjHV;;cAkHY,cAAc,EAAA,EAEjB;QApHT;UAuHU,QAAQ,EAAA;UAvHlB;YA0HY,WAAW,EAAA;QA1HvB;UA+HU,QAAQ,EAAA;QA/HlB;UAmIU,QAAQ,EAAA;QAnIlB;UAuIU,QAAQ,EAAA;UACR;YAxIV;cAyIY,QAAQ,EAAA,EAEX;QA3IT;UA8IU,QAAQ,EAAA;QA9IlB;UAkJU,aAAa;UACb,QAAQ,EAAA;UACR;YApJV;cAqJY,cAAc,EAAA,EAEjB;MAvJT;QA2JQ,kBAAkB,EAAA;QA3J1B;;;UA+JU,kBAAkB;UAClB,SAAS;UACT,yBAAyB;UACzB,YAAY;UACZ,YAAY;UACZ,WAAW;UACX,oBAAoB;UACpB,uBAAuB;UACvB,mBAAmB;UACnB,kBAAkB;UAClB,WAAW;UACX,YAAY;UACZ,eAAe,EAAA;UAEf;YA7KV;;;cA8KY,aAAa,EAAA,EAEhB;EAhLT;IAwLI,WAAW,EAAA;IAxLf;MA2LM,6BAA6B,EAAA;MAC7B;QA5LN;UA6LQ,wBAAwB,EAAA,EAkB3B;MA/ML;QAkMU,UAAU,EAAA;QACV;UAnMV;YAoMY,kBAAkB,EAAA,EASrB;QAJG;UAzMZ;;YA0Mc,aAAa,EAAA,EAEhB;;AAOX;EACE;IACE,eAAe,EAAA;EAEjB;IAIQ,eAAe;IACf,mBAAmB,EAAA,EACpB;;AAMT;EACE,mBAAmB,EAAA;;AAGrB;EAEI,iBAAiB;EACjB,gBAAgB,EAAA;;AAHpB;EAOI,qBAAqB;EACrB,eAAe;EACf,cAAc,EAAA;;AAIlB;EACE,uBAAuB;EACvB,eAAe,EAAA;EAFjB;IAKI,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,cAAc,EAAA;IAlBlB;MAqBM,WAAW;MACX,WAAW;MACX,cAAc;MACd,wBAAwB;MACxB,gDAAqC,EAAA;;AAK3C;EACE;IAIQ,eAAe;IACf,mBAAmB,EAAA,EACpB;;AAOP;EADF;IAGM,WAAW,EAAA;IAHjB;MAMQ,WAAW,EAAA,EACZ;;AAPP;EAYI,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,yBAAyB,EAAA;;AAlB7B;EAsBI,aAAa,EAAA;;AAIjB;;EAEE,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB;EAChB,yBAAyB,EAAA;EAF3B;IAKI,eAAe;IACf,gBAAgB;IAChB,mBAAmB,EAAA;IAPvB;MAUM,SAAS;MACT,iBAAiB,EAAA;MAXvB;QAcQ,UAAU;QACV,YAAY;QACZ,iBAAiB;QACjB,cAAc;QACd,kBAAkB,EAAA;EAKxB;IAvBF;MAwBI,eAAe,EAAA,EAWlB;EATC;IA1BF;MA2BI,kBAAkB,EAAA,EAQrB;EAnCD;IA+BI,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC,EAAA;;AAItC;EAEI,kBAAkB,EAAA;;AAFtB;EAMI,eAAe;EACf,gBAAgB,EAAA;;AAIhB;EAXJ;IAYM,eAAe,EAAA,EAyBlB;;AArCH;;EAiBM,eAAe,EAAA;;AAjBrB;EAsBQ,SAAS,EAAA;EAtBjB;;IA2BY,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,6CAA4C;IAC5C,eAAe,EAAA;;AAQ3B;EACE,kBAAkB,EAAA;EAGhB;IAJJ;MAKM,kBAAkB;MAClB,QAAQ,EAAA,EAMX;EAJC;IARJ;MASM,YAAY;MACZ,kBAAkB,EAAA,EAErB;;AAGH;EACE;IAEI,aAAa,EAAA,EACd;;AAIL;EACE,aAAa;EACb,SAAS,EAAA;EAFX;IAKI,aAAa;IACb,mBAAmB,EAAA;EANvB;IAUI,gDAA+B,EAAA;EAVnC;IAcI,gDAA6B,EAAA;IAC7B;MAfJ;QAgBM,WAAW,EAAA,EAKd;IAHC;MAlBJ;QAmBM,YAAY,EAAA,EAEf;;AAGH;EAEI,gDAA6B;EAQ7B,QAAQ;EACR,kBAAkB,EAAA;EARlB;IAHJ;MAIM,WAAW,EAAA,EAQd;EANC;IANJ;MAOM,YAAY;MACZ,QAAQ,EAAA,EAIX;;AAED;EAdF;IAgBM,iBAAiB,EAAA,EAClB;;AAIL;EACE,gDAA6B;EAC7B,YAAY;EACZ,QAAQ;EACR,kBAAkB,EAAA;;AAGpB;EACE,wBAAwB,EAAA;;AAG1B;;EAEE,yBAAyB,EAAA;;AAG3B;EACE,cAAc,EAAA;;AAGhB;;;EAGE,YAAY,EAAA;;AAGd;;EAEE,YAAY;EACZ,kCAAkC;EAClC,oCAAoC;EACpC,8BAA8B;EAC9B,qCAAqC;EACrC,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE;IAGM,UAAU,EAAA;EAIhB;IAGM,WAAW;IACX,YAAY,EAAA;EAKlB;IAEI,aAAa,EAAA;EAIjB;IACE,eAAe;IACf,yBAAyB,EAAA,EAC1B;;AAGH;EACE,YAAY,EAAA;;AAGd;EACE,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAA;;AAGX;EAEI,2BAA2B,EAAA;;AAI/B;EACE,aAAa,EAAA;;AAGf;EACE,kBAAkB,EAAA;;AAGpB;EAIQ,eAAe;EACf,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B,EAAA;EAVtC;IAaU,kBAAkB;IAClB,aAAa,EAAA;IAdvB;MAiBY,gBAAgB,EAAA;EAIpB;IArBR;MAsBU,mBAAmB;MACnB,0CAA0C;MAC1C,SAAS;MACT,OAAO;MACP,WAAW;MACX,yBAAyB;MACzB,gBAAgB,EAAA,EAEnB;;AA9BP;EAkCM,iBAAiB;EACjB,YAAY,EAAA;;AAnClB;EAuCM,WAAW;EACX,eAAe,EAAA;;AAxCrB;EA4CM,mBAAmB,EAAA;EACnB;IA7CN;MA8CQ,eAAe;MACf,gBAAgB,EAAA;MA/CxB;QAiDU,aAAa,EAAA;QAjDvB;UAoDY,cAAc;UACd,mBAAmB,EAAA,EACpB;EAtDX;;IA8DY,iBAAiB,EAAA","sourcesContent":["//.subsubmenu_category li a{\r\n//  text-transform: lowercase!important;\r\n//}\r\n//.subsubmenu_category li a:first-letter{\r\n//  text-transform: uppercase!important;\r\n//}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .access_rapide,\r\n  .bloc_reassurance {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .mobile {\r\n    display: flex;\r\n    align-items: center;\r\n    > div {\r\n      margin: 0 8px;\r\n    }\r\n  }\r\n  .advtm_menu_5 .adtm_sub .subsubmenu_category li > div {\r\n    display: flex;\r\n    padding: 0 !important;;\r\n    margin: 0 !important;\r\n  }\r\n  .advtm_menu_5 .adtm_sub .subsubmenu_category li > div > div {\r\n    width: 50%;\r\n    padding: 0 !important;;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .advtm_menu_5 .adtm_sub .subsubmenu_category li > div > div a:after {\r\n    content: none !important;\r\n  }\r\n\r\n  .advtm_menu_5 .adtm_sub .subsubmenu_category li > div > div .column_wrap_title {\r\n    margin: 5px !important;\r\n  }\r\n  .advtm_menu_5 .adtm_sub .subsubmenu_category {\r\n    min-height: 80vh !important;\r\n  }\r\n\r\n  #adtm_menu.adtm_menu_toggle_open ul#menu li div.adtm_sub {\r\n    height: 80vh !important;\r\n  }\r\n\r\n  #_mobile_top_menu {\r\n    max-width: 80%;\r\n    display: none;\r\n    overflow: scroll;\r\n    position: absolute !important;\r\n    top: 0;\r\n    right: -100%;\r\n    margin: 0;\r\n    background: white;\r\n    height: 100vh;\r\n    z-index: 800;\r\n\r\n    .burger_header {\r\n      padding: 28px 20px 10px 20px;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      background: white;\r\n    }\r\n\r\n    .mobile_mode {\r\n      padding: 30px;\r\n      position: relative;\r\n      display: flex;\r\n\r\n      .close_icon {\r\n        margin-left: auto;\r\n      }\r\n    }\r\n\r\n    .adtm_submenu_toggle_open {\r\n      .columnWrapTable {\r\n        display: none;\r\n      }\r\n\r\n    }\r\n\r\n    .back_sub {\r\n      span {\r\n        padding: 0;\r\n      }\r\n    }\r\n\r\n    .li-niveau1 {\r\n      a {\r\n        &:hover {\r\n          &:after {\r\n            display: none !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .language-selector-wrapper {\r\n      select {\r\n        -webkit-appearance: none;\r\n        -moz-appearance: none;\r\n        text-indent: 1px;\r\n        text-overflow: '';\r\n      }\r\n    }\r\n\r\n    .sub,\r\n    .li-niveau1 a.a-niveau1 {\r\n      border: none !important;\r\n    }\r\n\r\n    .adtm_sub {\r\n      border: none !important;\r\n\r\n      .back {\r\n        display: none;\r\n      }\r\n    }\r\n\r\n    .adtm_sub_open {\r\n      height: 100%;\r\n      transition: 0.5s all ease-in-out;\r\n      padding-left: 0;\r\n      top: 0;\r\n      position: absolute;\r\n      z-index: 100000;\r\n      background: white;\r\n      width: 100%;\r\n      left: 0;\r\n\r\n      a.a-niveau1 {\r\n        flex-direction: row-reverse;\r\n      }\r\n    }\r\n\r\n    .advtm_menu_span {\r\n      font-weight: initial ;\r\n    }\r\n\r\n    ul#menu li.li-niveau1 {\r\n      span {\r\n        background: white !important;\r\n      }\r\n    }\r\n  }\r\n  .background_opacity_menu {\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    width: 100%;\r\n    display: block;\r\n    position: fixed;\r\n    z-index: 12;\r\n    top: 0;\r\n    height: 110%;\r\n  }\r\n  .bloc_reassurance {\r\n    padding: 40px;\r\n    border-top: 1px solid #ece6dc;\r\n    text-align: center;\r\n  }\r\n  .access_rapide {\r\n    display: flex;\r\n    justify-content: center;\r\n\r\n    a {\r\n      margin: auto;\r\n      color: black;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n@media screen and (max-width: 800px) {\r\n  #_mobile_top_menu #menu {\r\n    padding-left: 15px !important;\r\n    padding-right: 25px !important;\r\n  }\r\n\r\n  #adtm_menu .li-niveau1 {\r\n    margin-bottom: 15px;\r\n  }\r\n  #adtm_menu .adtm_elements li a {\r\n    padding-left: 0 !important;\r\n  }\r\n  #adtm_menu .li-niveau1,\r\n  #adtm_menu .li-niveau1 a.a-niveau1,\r\n  #adtm_menu .li-niveau1 a.a-niveau1 .advtm_menu_span {\r\n    line-height: 1;\r\n    min-height: 0 !important;\r\n    max-height: 25px !important;\r\n    font-size: 1rem !important;\r\n    color: black;\r\n    text-transform: none !important;\r\n    font-weight: 300 !important;\r\n  }\r\n  #adtm_menu .li-niveau1 a.a-niveau1 > span {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    position: relative;\r\n  }\r\n\r\n  #adtm_menu .li-niveau1 a.a-niveau1 > :after {\r\n    content: \"\";\r\n    display: block;\r\n    width: 7px;\r\n    height: 7px;\r\n    border: solid 2px #153147;\r\n    position: absolute;\r\n    right: -5px;\r\n    transform: rotate(45deg);\r\n    border-left: none;\r\n    border-bottom: none\r\n  }\r\n  #_mobile_top_menu .close_icon {\r\n    opacity: 1;\r\n    text-align: right;\r\n\r\n    img {\r\n      width: auto;\r\n      height: auto;\r\n    }\r\n  }\r\n  #_mobile_top_menu .burger_header .close_icon {\r\n    margin: 0 !important;\r\n    position: relative;\r\n  }\r\n  #_mobile_top_menu .close_icon:after {\r\n    content: url(../img/close.svg);\r\n    display: block;\r\n    width: 18px;\r\n    height: 18px;\r\n  }\r\n  #_mobile_top_menu .mobile_mode {\r\n    padding-left: 15px;\r\n  }\r\n  #_mobile_top_menu .mobile_mode .dropdown select {\r\n    color: black;\r\n    font-weight: normal !important;\r\n    font-family: \"Oswald\", sans-serif;\r\n  }\r\n\r\n  #_mobile_top_menu .mobile_mode .dropdown img {\r\n    height: 15px;\r\n    width: auto;\r\n    margin-left: 5px;\r\n  }\r\n\r\n\r\n  #_mobile_top_menu .mobile_mode .dropdown {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n\r\n  #_mobile_top_menu {\r\n    .back_sub {\r\n      cursor: pointer;\r\n    }\r\n\r\n    .adtm_sub a {\r\n      color: #252626 !important;\r\n      position: relative;\r\n      font-family: \"Roboto\", sans-serif;\r\n      font-weight: 300 !important;\r\n    }\r\n\r\n    .adtm_sub > .columnWrapTable {\r\n      padding: 0 15px;\r\n    }\r\n\r\n    .next_sub {\r\n      position: absolute;\r\n      right: 0;\r\n      top: 0;\r\n      width: 50px;\r\n      height: 20px;\r\n    }\r\n\r\n    .adtm_sub .column_wrap_title .next_sub:after {\r\n      content: \"\";\r\n      display: block;\r\n      width: 10px;\r\n      height: 10px;\r\n      border: solid 2px #F08243;\r\n      position: absolute;\r\n      right: 5px;\r\n      transform: translate(0, -50%) rotate(45deg);\r\n      border-left: none;\r\n      border-bottom: none;\r\n      top: 10px;\r\n    }\r\n\r\n    .adtm_sub .subsubmenu_category > li .adtm_column_wrap,\r\n    .adtm_sub .subsubmenu_category > li .adtm_column_wrap .subcategoryTrue {\r\n      padding-top: 0 !important;\r\n      padding-bottom: 0 !important;\r\n      margin: 0 !important;\r\n    }\r\n\r\n\r\n    .adtm_sub .subsubmenu_category > li .adtm_column_wrap .adtm_column_wrap_sizer {\r\n      display: none;\r\n    }\r\n\r\n    .adtm_sub p {\r\n      padding: 0 10px;\r\n    }\r\n\r\n    .adtm_sub .adtm_column .column_wrap_title {\r\n      position: relative;\r\n      margin-bottom: 0 !important;\r\n      padding-bottom: 0 !important;\r\n    }\r\n\r\n    .adtm_sub,\r\n    .subsubmenu_category {\r\n      padding-top: 10px\r\n    }\r\n  }\r\n}\r\n\r\n#_mobile_top_menu .access_rapide {\r\n  margin-left: 30px;\r\n  margin-right: 25px;\r\n  margin-top: 25px;\r\n  flex-wrap: wrap;\r\n  display: flex;\r\n  padding: 10px 10px 0;\r\n  box-shadow: 0 3px 6px #00000029;\r\n}\r\n\r\n#_mobile_top_menu .access_rapide a {\r\n  width: 100%;\r\n  margin-bottom: 15px\r\n}\r\n\r\n#_mobile_top_menu .access_rapide a img {\r\n  width: 17px;\r\n  margin-right: 10px;\r\n\r\n}\r\n\r\n.burger_header {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n}\r\n\r\n.burger_header .back_sub {\r\n  font-size: 14px;\r\n  font-weight: 300;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 50%;\r\n}\r\n\r\n.burger_header .close_icon:after {\r\n  width: 50%;\r\n  position: absolute;\r\n  right: 0;\r\n}\r\n\r\n.burger_header .close_icon {\r\n  width: 50%;\r\n}\r\n\r\n.burger_header .sub_title {\r\n  width: 100%;\r\n  margin-top: 25px;\r\n  padding-left: 5px;\r\n  color: #F08243 !important;\r\n  font-size: 20px;\r\n  font-weight: 600 !important;\r\n}\r\n\r\n.burger_header .sub_title .advtm_menu_span {\r\n  color: #F08243;\r\n  font-weight: 700!important;\r\n  font-size: 20px;\r\n}\r\n\r\n.background_opacity_menu {\r\n  display: none !important;\r\n}\r\n\r\n#header.is-open:before {\r\n  content: '';\r\n  display: block;\r\n  max-width: 20%;\r\n  background: rgba(32, 31, 31, 0.7);\r\n  height: 100vh;\r\n  width: 100%;\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  z-index: 9\r\n}\r\n","#category {\r\n  #amazzing_filter {\r\n    box-shadow: none !important;\r\n  }\r\n  #js-product-list-header {\r\n    @media screen and (max-width: 767px) {\r\n      margin-bottom: 15px;\r\n    }\r\n    .read_less,\r\n    .read_more {\r\n      margin-top: 5px;\r\n      font-size: 14px;\r\n      font-weight: bolder;\r\n    }\r\n\r\n    .block-category {\r\n      h1 {\r\n        @media screen and (max-width: 767px) {\r\n          font-size: 1.5rem;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}","@import \"components/menu\";\r\n@import \"components/category\";\r\n@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\r\n\r\n@media screen and (max-width: 767px) {\r\n  main {\r\n    overflow-x: hidden;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .header-top {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n#checkout {\r\n  .cart-grid-body {\r\n    .nav-link {\r\n      font-size: 0.9rem;\r\n    }\r\n  }\r\n}\r\n\r\n.product-line-grid-right {\r\n  .qty {\r\n    padding-right: 0;\r\n  }\r\n}\r\n\r\n#prestablogfront {\r\n  .date {\r\n    display: none;\r\n  }\r\n}\r\n\r\n#header {\r\n  .header-nav {\r\n    @media screen and (max-width: 767px) {\r\n      .row {\r\n        margin: 0 !important;\r\n      }\r\n    }\r\n    border: none;\r\n\r\n    .user-info {\r\n      margin-left: 0 !important;\r\n      margin-right: 1rem;\r\n    }\r\n  }\r\n\r\n  .header-banner {\r\n    ul {\r\n      li {\r\n        * {\r\n          font-family: \"Montserrat\", sans-serif;\r\n          font-weight: 400;\r\n        }\r\n      }\r\n    }\r\n\r\n    .splide {\r\n      overflow: hidden;\r\n      max-height: 56px;\r\n\r\n      .splide__slide {\r\n        text-align: center;\r\n        line-height: 56px;\r\n      }\r\n\r\n      .close_element {\r\n        content: url(../img/close.svg);\r\n        float: right;\r\n        position: relative;\r\n        top: -40px;\r\n        right: 40px;\r\n        color: white;\r\n        cursor: pointer;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n#products {\r\n  .product-title {\r\n    min-height: 40px;\r\n  }\r\n}\r\n\r\n#product {\r\n  .input-group {\r\n    max-width: 80px;\r\n    text-align: center;\r\n    border-radius: 10px;\r\n  }\r\n  .h1 {\r\n    text-transform: initial !important;\r\n  }\r\n}\r\n\r\n.block-category-inner {\r\n  flex-direction: column;\r\n}\r\n\r\n.product-actions {\r\n  border: none !important;\r\n  padding: 0 !important;\r\n  margin: 0 0 30px !important;\r\n}\r\n\r\n.icon-amz {\r\n  margin-right: 10px;\r\n}\r\n\r\n.product-actions .add a {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.btn-primary {\r\n  background-color: #163047 !important;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6, p, span, a {\r\n  font-family: \"Inter\", sans-serif !important;\r\n}\r\n\r\n#header-pickleball {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  padding: 15px 0;\r\n  transition: all .15s ease;\r\n}\r\n\r\n.header-top {\r\n  .container {\r\n    width: 1280px;\r\n\r\n    #menu {\r\n      justify-content: center !important;\r\n    }\r\n  }\r\n}\r\n\r\nheader#header {\r\n  #_desktop_cart {\r\n    order: 2;\r\n  }\r\n\r\n  #adtm_menu ul#menu {\r\n    justify-content: center !important;\r\n  }\r\n\r\n  transition: transform .30s ease;\r\n  transform: translateY(0px);\r\n  width: 100%;\r\n  top: 0;\r\n  z-index: 200;\r\n  @media screen and (max-width: 767px) {\r\n    width: 100vw;\r\n  }\r\n\r\n  #header-pickleball-wrapper {\r\n    @media screen and (min-width: 768px) {\r\n      padding-top: 20px;\r\n    }\r\n    background: white;\r\n\r\n    #header-pickleball {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      flex-wrap: wrap;\r\n      padding: 0;\r\n      transition: all .15s ease;\r\n\r\n      .logo-wrapper {\r\n        @media screen and (max-width: 767px) {\r\n          order: 1;\r\n          padding-bottom: 10px;\r\n          width: 45%;\r\n        }\r\n        @media screen and (min-width: 768px) {\r\n          padding-top: 10px;\r\n        }\r\n\r\n        img {\r\n          @media screen and (max-width: 767px) {\r\n            width: 200px !important;\r\n          }\r\n        }\r\n      }\r\n\r\n      .search-wrapper {\r\n        width: 543px;\r\n        max-width: 100%;\r\n        padding-top: 14px;\r\n        @media screen and (max-width: 767px) {\r\n          order: 3;\r\n          width: 100%;\r\n          margin: 0 0 0 0;\r\n        }\r\n\r\n        #search_widget {\r\n          float: none;\r\n\r\n          i {\r\n            padding: 0;\r\n            right: 5px;\r\n            top: 17px;\r\n            color: #163047 !important;\r\n          }\r\n\r\n          input {\r\n            border-radius: 0;\r\n            padding: 5px 35px 5px 5px;\r\n            height: 55px;\r\n          }\r\n        }\r\n      }\r\n\r\n      .icons-wrapper {\r\n        @media screen and (max-width: 767px) {\r\n          order: 2;\r\n        }\r\n        flex-shrink: 0;\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        a {\r\n          cursor: pointer;\r\n        }\r\n\r\n        @media screen and (min-width: 768px) {\r\n          padding-top: 14px;\r\n          > div {\r\n            margin: 0 11px;\r\n          }\r\n        }\r\n\r\n        .icon-header {\r\n          @media screen and (max-width: 767px) {\r\n            width: 17px;\r\n            height: 15px;\r\n          }\r\n        }\r\n\r\n        #_desktop_user_info,\r\n        #_desktop_cart {\r\n          @media screen and (max-width: 767px) {\r\n            display: none;\r\n          }\r\n        }\r\n\r\n        #_mobile_cart,\r\n        #_mobile_user_info {\r\n          display: none;\r\n          @media screen and (max-width: 767px) {\r\n            display: block;\r\n          }\r\n        }\r\n\r\n        #_desktop_user_info {\r\n          order: 1;\r\n\r\n          img {\r\n            width: auto;\r\n          }\r\n        }\r\n\r\n        #_mobile_user_info {\r\n          order: 2;\r\n        }\r\n\r\n        #icon-wishlist-wrapper {\r\n          order: 3;\r\n        }\r\n\r\n        #ps-shoppingcart-wrapper {\r\n          order: 4;\r\n          @media screen and (max-width: 767px) {\r\n            order: 1;\r\n          }\r\n        }\r\n\r\n        #_mobile_cart {\r\n          order: 5;\r\n        }\r\n\r\n        #menu-icon {\r\n          display: none;\r\n          order: 6;\r\n          @media screen and (max-width: 767px) {\r\n            display: block;\r\n          }\r\n        }\r\n      }\r\n\r\n      .blockcart, #icon-wishlist-wrapper {\r\n        position: relative;\r\n\r\n        .wishlist-products-count,\r\n        .cart-products-count {\r\n          position: absolute;\r\n          top: -3px;\r\n          background-color: #EB622E;\r\n          color: white;\r\n          bottom: -8px;\r\n          right: -5px;\r\n          display: inline-flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n          border-radius: 50%;\r\n          width: 17px;\r\n          height: 17px;\r\n          font-size: 12px;\r\n\r\n          @media screen and (max-width: 767px) {\r\n            bottom: -10px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n\r\n  }\r\n\r\n  &.sticky {\r\n    width: 100%;\r\n\r\n    &.partial {\r\n      transform: translateY(-150px);\r\n      @media screen and (max-width: 767px) {\r\n        transform: translateY(0);\r\n      }\r\n\r\n      #header-wimod-wrapper {\r\n        #header-wimod {\r\n          padding: 0;\r\n          @media screen and (max-width: 767px) {\r\n            padding: 5px 0 0 0;\r\n          }\r\n\r\n          .logo-wrapper,\r\n          .icons-wrapper {\r\n            @media screen and (max-width: 767px) {\r\n              display: none;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .breadcrumb {\r\n    font-size: 12px;\r\n  }\r\n  .product-container {\r\n    .product-price {\r\n      .current-price {\r\n        .current-price-value {\r\n          font-size: 20px;\r\n          font-weight: bolder;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.caracteristic-name {\r\n  font-weight: bolder;\r\n}\r\n\r\n.product-container {\r\n  .h1 {\r\n    font-size: 1.6rem;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .product-price {\r\n    display: inline-block;\r\n    max-width: 100%;\r\n    color: #232323;\r\n  }\r\n}\r\n\r\n.card-header {\r\n  background-color: white;\r\n  padding-left: 0;\r\n\r\n  h2 {\r\n    margin-bottom: 0 !important;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    appearance: none;\r\n    outline: none;\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 1.14rem;\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-weight: 700;\r\n    color: #232323;\r\n\r\n    &:after {\r\n      width: 16px;\r\n      height: 9px;\r\n      display: block;\r\n      transform-origin: bottom;\r\n      content: url(../img/chevron-haut.svg);\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .product-container {\r\n    .product-price {\r\n      .current-price {\r\n        .current-price-value {\r\n          font-size: 24px;\r\n          font-weight: bolder;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.product-quantity {\r\n  @media screen and (max-width: 767px) {\r\n    .add {\r\n      width: 100%;\r\n\r\n      button {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n\r\n  #quantity_wanted {\r\n    text-align: center;\r\n    width: 3rem;\r\n    height: 2.75rem;\r\n    padding: .175rem .5rem;\r\n    color: #232323;\r\n    background-color: #fff;\r\n    border: 1px solid #232323;\r\n  }\r\n\r\n  .input-group-btn-vertical {\r\n    display: none;\r\n  }\r\n}\r\n\r\n#quantity_wanted,\r\n.add-to-cart {\r\n  border-radius: 10px;\r\n}\r\n\r\n.product-accessories {\r\n  margin-top: 50px;\r\n  background-color: #eeeeee;\r\n\r\n  .products-slider-wrapper {\r\n    max-width: 100%;\r\n    overflow-x: auto;\r\n    padding: 0 0 1rem 0;\r\n\r\n    .products {\r\n      margin: 0;\r\n      flex-wrap: nowrap;\r\n\r\n      .product {\r\n        padding: 0;\r\n        width: 212px;\r\n        margin: 0 8px 0 0;\r\n        flex-shrink: 0;\r\n        position: relative;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media screen and (min-width: 768px) {\r\n    padding: 24px 0;\r\n  }\r\n  @media screen and (max-width: 767px) {\r\n    padding: 24px 15px;\r\n  }\r\n\r\n  .h5 {\r\n    margin: 0 0 24px 0;\r\n    font-size: 2.14rem;\r\n    text-transform: initial !important;\r\n  }\r\n}\r\n\r\n#product {\r\n  #content {\r\n    max-width: initial;\r\n  }\r\n\r\n  #content-wrapper {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n\r\n  #accordion-infos {\r\n    @media screen and (max-width: 767px) {\r\n      padding: 0 15px;\r\n    }\r\n\r\n    li, span,\r\n    #description-truncate {\r\n      font-size: 13px;\r\n    }\r\n\r\n    .caracteristics {\r\n      .product-features {\r\n        margin: 0;\r\n\r\n        dl.data-sheet {\r\n          .name,\r\n          .value {\r\n            min-height: initial;\r\n            padding: 20px 0;\r\n            margin: 0;\r\n            background-color: white;\r\n            border-bottom: 1px solid rgba(0, 0, 0, .125);\r\n            font-size: 13px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.position-relative {\r\n  position: relative;\r\n\r\n  #_desktop_language_selector {\r\n    @media screen and (min-width: 768px) {\r\n      position: absolute;\r\n      right: 0;\r\n    }\r\n    @media screen and (max-width: 767px) {\r\n      padding: 5px;\r\n      text-align: center;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  #header-pickleball {\r\n    #_desktop_language_selector {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n.user-info {\r\n  display: flex;\r\n  gap: 10px;\r\n\r\n  a {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .icon-custom-logout {\r\n    content: url(../img/logout.svg);\r\n  }\r\n\r\n  .icon-custom-user {\r\n    content: url(../img/user.svg);\r\n    @media screen and (min-width: 768px) {\r\n      width: 30px;\r\n    }\r\n    @media screen and (max-width: 767px) {\r\n      height: 30px;\r\n    }\r\n  }\r\n}\r\n\r\n.blockcart {\r\n  .icon-custom-cart {\r\n    content: url(../img/cart.svg);\r\n    @media screen and (min-width: 768px) {\r\n      width: 35px;\r\n    }\r\n    @media screen and (max-width: 767px) {\r\n      height: 37px;\r\n      top: 2px;\r\n    }\r\n    top: 3px;\r\n    position: relative;\r\n  }\r\n\r\n  @media screen and (max-width: 767px) {\r\n    .cart-products-count {\r\n      top: 0 !important;\r\n    }\r\n  }\r\n}\r\n\r\n.icon-custom-burger {\r\n  content: url(../img/menu.svg);\r\n  height: 38px;\r\n  top: 5px;\r\n  position: relative;\r\n}\r\n\r\n.product-miniature .thumbnail-container:hover .product-description::after {\r\n  content: none !important;\r\n}\r\n\r\n.has-discount .discount,\r\n.product-flags li.product-flag.discount, .product-flags li.product-flag.discount-amount, .product-flags li.product-flag.discount-percentage {\r\n  background-color: #ef612d;\r\n}\r\n\r\n.has-discount .page-content.page-cms ul, .has-discount p, .has-discount.product-price, .page-content.page-cms .has-discount ul {\r\n  color: #ef612d;\r\n}\r\n\r\n.block-contact, .footer-container li a,\r\n.tabs .nav-tabs .nav-link,\r\np {\r\n  color: black;\r\n}\r\n\r\n.block_newsletter form input[type=email],\r\n#search_widget form input {\r\n  height: 55px;\r\n  background-color: white !important;\r\n  border: 1px solid #163047 !important;\r\n  border-radius: 10px !important;\r\n  padding: 5px 35px 5px 15px !important;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .product-information {\r\n    .product-description {\r\n      ul {\r\n        padding: 0;\r\n      }\r\n    }\r\n  }\r\n  .slick_images {\r\n    .image {\r\n      img {\r\n        width: 100%;\r\n        height: auto;\r\n      }\r\n    }\r\n  }\r\n\r\n  .js-product-container {\r\n    .scroll-box-arrows {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .slick-dots li button:before {\r\n    font-size: 50px;\r\n    color: #EB622E !important;\r\n  }\r\n}\r\n\r\n.product-miniature .product-title a {\r\n  color: black;\r\n}\r\n\r\n.product-miniature .product-title {\r\n  height: 40px;\r\n}\r\n\r\n.d-flex {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.block_bas {\r\n  h3 {\r\n    min-height: 40px !important;\r\n  }\r\n}\r\n\r\n.blog_desc {\r\n  height: 100px;\r\n}\r\n\r\n.text-center {\r\n  text-align: center;\r\n}\r\n\r\n#product {\r\n  #wrapper {\r\n    .product-add-to-cart {\r\n      &.stuck-down {\r\n        position: fixed;\r\n        z-index: 250;\r\n        left: 15px;\r\n        width: calc(100% - 30px);\r\n        bottom: 15px;\r\n        border-top: 1px solid #163047;\r\n        box-shadow: 0 -1px 6px #163047;\r\n\r\n        .product-prices {\r\n          text-align: center;\r\n          margin-top: 0;\r\n\r\n          > div {\r\n            margin-bottom: 0;\r\n          }\r\n        }\r\n\r\n        @media screen and (max-width: 767px) {\r\n          transition: opacity;\r\n          animation: moveToBottom 0.5s ease-in-out 1;\r\n          bottom: 0;\r\n          left: 0;\r\n          width: 100%;\r\n          padding: 15px 15px 0 15px;\r\n          background: #FFF;\r\n        }\r\n      }\r\n    }\r\n\r\n    .container-pickleball {\r\n      max-width: 1140px;\r\n      margin: auto;\r\n    }\r\n\r\n    .container {\r\n      width: 100%;\r\n      max-width: none;\r\n    }\r\n\r\n    .breadcrumb {\r\n      margin-bottom: 1rem;\r\n      @media screen and (max-width: 767px) {\r\n        max-width: 100%;\r\n        overflow-x: auto;\r\n        ol {\r\n          display: flex;\r\n\r\n          li {\r\n            display: block;\r\n            white-space: nowrap;\r\n          }\r\n        }\r\n      }\r\n\r\n      ol {\r\n        li {\r\n          span,\r\n          a {\r\n            font-size: 0.8rem;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
